import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { getToken } from "../../../../helpers/Jwt";
import CurrencyInput from "../../../../helpers/CurrencyInput";
import MultiTagInput from "../../../ERPPPSU/component/MultiTagInput/MultiTagInput";
import RichTextEditor from "../../../Kejati/dashboard/News/RichTextEditor";
import ImagesRoom from "./ImagesRoom";

const EntryRoom = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({
        room_number: '',
        room_name: '',
        property_type: '',
        room_type: '',
        bed_type: '',
        capacity: '',
        price_weekday: '',
        price_weekend: '',
        description: '',

        //boolean value
        include_breakfast: 0,
        has_private_bathroom: 0,
        has_air_conditioning: 0,
        has_wifi: 0,
        has_tv: 0,
        has_balcony: 0,
    });

    const validationSchema = Yup.object().shape({
        // name: Yup.string().required('Nama Produk is wajib diisi.'),
        // unit: Yup.string().required('Satuan Produk is wajib diisi.'),
        // category: Yup.string().required('Kategori Produk is wajib diisi.')
    });

    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_ROOM = "api/staynest/dashboard/Rooms";
    const PATH_FACILITY_OPTION = "api/staynest/dashboard/Facilites/option";

    const [loadingFacilities, setLoadingFacilities] = useState(false);
    const [facilities, setFacilities] = useState([]);

    // Fetch data from the API
    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_ROOM}/detail?id=${id}`,).then((room) => {

                setInitialValues({
                    room_name: room.room_name || '',
                    room_number: room.room_number || '',
                    property_type: room.property_type || '',
                    room_type: room.room_type || '',
                    bed_type: room.bed_type || '',
                    capacity: room.capacity || '',
                    price_weekday: room.price_weekday || '',
                    price_weekend: room.price_weekend || '',
                    description: room.description || '',

                    //boolean value
                    // include_breakfast: 0,
                    // has_private_bathroom: 0,
                    // has_air_conditioning: 0,
                    // has_wifi: 0,
                    // has_tv: 0,
                    // has_balcony: 0,
                });

            });
        }
    }, [id]);

    useEffect(() => {
        setLoadingFacilities(true);
        fetchData(`${BASE_URL}${PATH_FACILITY_OPTION}`,).then((data) => {
            setFacilities(data);
        }).finally(() => {
            setLoadingFacilities(false);
        });
    }, []);

    const onSubmit = async (values, requests) => {
        try {
            const payload = {
                id,
                ...values,
                facilites: selectedFacilities
            };

            await axios.post(`${BASE_URL}${PATH_ROOM}`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });

        } catch (error) {
            alert(error);
            console.error('Error submitting form:', error);
        } finally {
            requests.setSubmitting(false);
            navigate('/activity-staynest/manage-rooms');
        }
    };

    const [selectedFacilities, setselectedFacilities] = useState([]);
    const handleFacilitesChange = (tags) => {
        setselectedFacilities(tags);
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">
                {id ? `Edit Kamar` : 'Tambah Kamar'}
            </h2>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>

                        <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-6">

                            <div className="gap-4 px-4">
                                <label htmlFor="room_name">Nama Kamar/Ruangan</label>
                                <Field
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    name="room_name" />
                                <ErrorMessage name="room_name" component="p" className='text-red-500 text-xs mt-1' />
                            </div>
                            <div className="gap-4 px-4">
                                <label htmlFor="room_number">No. Kamar</label>
                                <Field
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    name="room_number" />
                                <ErrorMessage name="room_number" component="p" className='text-red-500 text-xs mt-1' />
                            </div>
                            <div className="gap-4 px-4">
                                <label htmlFor="room_type">Jenis Kamar</label>
                                <Field
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    name="room_type" />
                                <ErrorMessage name="room_type" component="p" className='text-red-500 text-xs mt-1' />
                            </div>
                            <div className="gap-4 px-4">
                                <label htmlFor="bed_type">Jenis Kasur</label>
                                <Field
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    name="bed_type" />
                                <ErrorMessage name="bed_type" component="p" className='text-red-500 text-xs mt-1' />
                            </div>
                            <div className="gap-4 px-4">
                                <label htmlFor="capacity">Kapasitas Orang</label>
                                <Field
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    name="capacity" />
                                <ErrorMessage name="capacity" component="p" className='text-red-500 text-xs mt-1' />
                            </div>
                            <div className="gap-4 px-4">
                                <label htmlFor="property_type">Jenis Properti</label>
                                <Field
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    name="property_type" />
                                <ErrorMessage name="property_type" component="p" className='text-red-500 text-xs mt-1' />
                            </div>
                            <div className="gap-4 px-4">
                                <label className="block text-sm text-gray-600">Harga Weekday</label>
                                <CurrencyInput
                                    id="price_weekday"
                                    name="price_weekday"
                                    currency="IDR"
                                    placeholder="Masukkan Harga Weekday"
                                    value={values.price_weekday}
                                    onChange={(value) => setFieldValue('price_weekday', value)}
                                    className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 text-end"
                                />
                            </div>
                            <div className="gap-4 px-4">
                                <label className="block text-sm text-gray-600">Harga Weekend</label>
                                <CurrencyInput
                                    id="price_weekend"
                                    name="price_weekend"
                                    currency="IDR"
                                    placeholder="Masukkan Harga Weekday"
                                    value={values.price_weekend}
                                    onChange={(value) => setFieldValue('price_weekend', value)}
                                    className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 text-end"
                                />
                            </div>

                        </div>
                        <div className="gap-4 px-4 py-4">
                            <label className="block text-sm text-gray-600">Keterangan</label>
                            <RichTextEditor
                                value={values?.description}
                                onChange={(value) => setFieldValue('description', value)}
                            />
                        </div>
                        <div className="p-3">
                            <label htmlFor="facilities">Fasilitas</label>
                            <MultiTagInput name="facilities" options={facilities} onTagsChange={handleFacilitesChange} />
                        </div>

                        <div className="m-4">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                            >
                                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>

            {id != null ? (
                <ImagesRoom id={id}/>
            ) : (<p></p>)}
        </div>
    );
};

export default EntryRoom;
